import './NavBar.css';

import { useState } from 'react';

function NavBar({page, updatePage}) {
    const [menuIsOpen, setMenuIsOpen] = useState(false)

    return(
        <div>
            <nav className='NavBar-banner'>
                <button onClick={() => setMenuIsOpen(prev => !prev)}>
                    <div className='menuBurger'>
                        <div className='menuBar'></div>
                        <div className='menuBar'></div>
                        <div className='menuBar'></div>
                    </div>
                </button>
                <button className={page === 0 ? 'NavBar-tab-active' : 'NavBar-tab'} onClick={() => updatePage(0)}>
                    Journal Comptable
                </button>
                <button className={page === 1 ? 'NavBar-tab-active' : 'NavBar-tab'} onClick={() => updatePage(1)}>
                    Grand Livre
                </button>
                <button className={page === 2 ? 'NavBar-tab-active' : 'NavBar-tab'} onClick={() => updatePage(2)}>
                    Balance
                </button>
                <button className={page === 3 ? 'NavBar-tab-active' : 'NavBar-tab'} onClick={() => updatePage(3)}>
                    Compte de résultat
                </button>
                <button className={page === 4 ? 'NavBar-tab-active' : 'NavBar-tab'} onClick={() => updatePage(4)}>
                    Bilan
                </button>
                <button className={page === 5 ? 'NavBar-tab-active' : 'NavBar-tab'} onClick={() => updatePage(5)}>
                    Data Comptes
                </button>
            </nav>
            {menuIsOpen && (
                <div className='menuPopUp'>
                    <button className='menuPopUp-tab'>Action 1</button>
                    <button className='menuPopUp-tab'>Action 2</button>
                    <button className='menuPopUp-tab'>Action 3</button>
                </div>
            )}
        </div>
    );
}


export default NavBar